<template>
  <master-admin-header>
    <template v-slot:left>
      <div class="l-mainHeader__gMenuItem">
        <SiteMenuContainer>
          <template v-slot:activator="{ on }">
            <div class="d-inline" v-on="on">
              <HeaderMenuItem :active="isActive(siteMenuItem.router)">
                <v-icon>mdi-open-in-app</v-icon>
                <span>サイト管理</span>
                <v-icon>mdi-menu-down</v-icon>
              </HeaderMenuItem>
            </div>
          </template>
        </SiteMenuContainer>
      </div>
      <router-link
        v-for="(item, index) in globalMenuItems"
        :key="index"
        :to="item.router"
      >
        <HeaderMenuItem :active="isActive(item.router)">
          <v-icon>{{ item.icon }}</v-icon>
          <span>{{ item.text }}</span>
        </HeaderMenuItem>
      </router-link>
    </template>
    <template v-slot:right>
      <a href="https://support.b-cms.jp" target="_blank" class="mx-2">
        <v-icon color="grey lighten-1"> mdi-help-circle-outline</v-icon>
      </a>
      <AccountMenu :user-name="currentUserAuth.name">
        <template v-slot:activator="{ on }">
          <div class="ma-2 p-accountIcon" v-on="on">
            <div>
              <v-icon class="p-accountIcon__img" color="grey">
                mdi-account
              </v-icon>
            </div>
          </div>
        </template>
      </AccountMenu>
    </template>
  </master-admin-header>
</template>

<script>
import { mapState } from 'vuex'
import LogoutBtn from '@/components/commons/LogoutBtn'
import MasterAdminHeader from '/src/components/shared/MasterAdminHeader'
import AccountMenu from '/src/components/shared/MasterAdminHeader/AccountMenu'
import SiteMenuContainer from './SiteMenuContainer'
import HeaderMenuItem from '/src/components/shared/MasterAdminHeader/HeaderMenuItem'

export default {
  name: 'MasterAdminHeaderContainer',
  components: {
    HeaderMenuItem,
    SiteMenuContainer,
    AccountMenu,
    MasterAdminHeader,
    LogoutBtn
  },
  data () {
    return {
      accountMenu: false,
      siteMenuItem: {
        icon: 'mdi-open-in-app',
        text: 'サイト管理',
        router: { name: 'masterAdminSites' }
      },
      globalMenuItems: [
        {
          icon: 'mdi-download',
          text: '発注レポート',
          router: { name: 'masterAdminOrderReports' }
        },
        {
          icon: 'mdi-account',
          text: 'ユーザー',
          router: { name: 'masterAdminUsers' }
        }
      ]
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => {
        return state.UserAuthStore.currentUserAuth
      }
    })
  },
  methods: {
    to (router) {
      return () => {
        if (this.isActive(router)) return
        this.$router.push(router)
      }
    },
    isActive (router) {
      const targetPath = this.$router.match({ name: router.name }).path
      return this.$route.path.indexOf(targetPath) === 0
    }
  }
}
</script>

<style scoped lang="sass">
.p-accountIcon
  vertical-align: middle
  &__img
    display: block
    border: 2px solid #D3D3D3
    border-radius: 50%
    height: 40px
    width: 40px
    &:hover
      cursor: pointer
.accountMenu
  z-index: 999
</style>
